import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import svgPaths from "./svgPaths";
import imgFrame427321791 from "../assets/images/801c36195628ec9551d571118f7e538a22e2ed29.png";
import imgImage60 from "../assets/images/0e749a998ab683cfd985c639d3b6b77d2c9459ca.png";

function FooterBranding() {
  return (
    <div className="flex flex-col gap-6 items-center lg:items-start text-center lg:text-left w-full lg:w-[534px]" data-name="Footer branding block">
      {/* Footer Logo */}
      <Link to="/" className="h-[51px] relative w-[124px] block cursor-pointer">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img alt="Fixezy Logo" className="absolute h-[376.6%] left-[-20.16%] max-w-none top-[-138.3%] w-[142.74%]" src={imgFrame427321791} />
        </div>
      </Link>
      {/* Bio */}
      <p className="font-['Roboto:Regular',sans-serif] font-normal leading-relaxed text-[#9b9b9c] text-[14px]" style={{ fontVariationSettings: '"wdth" 100' }}>
        Fixezy connects you with trusted professionals for all your home service needs. From repairs and maintenance to cleaning, appliance care, and beauty services, enjoy reliable, on-time solutions delivered right to your doorstep.
      </p>
      {/* Social links */}
      <div className="flex gap-[12px] items-center justify-center">
        {/* FB */}
        <div className="size-[34px] bg-white border border-black/5 shadow-sm rounded-full flex items-center justify-center cursor-pointer hover:scale-105 active:scale-95 hover:bg-gray-50 transition-all" data-name="facebook logo">
          <svg className="size-[14px]" viewBox="0 0 7 14">
            <path d={svgPaths.p50d1c80} fill="var(--fill-0, #192031)" />
          </svg>
        </div>
        {/* Twitter */}
        <div className="size-[34px] bg-white border border-black/5 shadow-sm rounded-full flex items-center justify-center cursor-pointer hover:scale-105 active:scale-95 hover:bg-gray-50 transition-all" data-name="Twitter logo">
          <svg className="w-[18px] h-[14px]" viewBox="0 0 18 14">
            <path d={svgPaths.pd4cb240} fill="var(--fill-0, #192031)" />
          </svg>
        </div>
        {/* LinkedIn */}
        <div className="size-[34px] bg-white border border-black/5 shadow-sm rounded-full flex items-center justify-center cursor-pointer hover:scale-105 active:scale-95 hover:bg-gray-50 transition-all" data-name="linkedin logo">
          <svg className="w-[16px] h-[15px]" viewBox="0 0 16 15">
            <path d={svgPaths.p21cf7400} fill="var(--fill-0, #192031)" />
          </svg>
        </div>
        {/* Insta */}
        <div className="size-[34px] bg-white border border-black/5 shadow-sm rounded-full flex items-center justify-center cursor-pointer hover:scale-105 active:scale-95 hover:bg-gray-50 transition-all" data-name="instagram logo">
          <svg className="w-[16px] h-[18px]" viewBox="0 0 16 18">
            <path d={svgPaths.p24a0f900} fill="var(--fill-0, #192031)" />
          </svg>
        </div>
      </div>
    </div>
  );
}

function FooterNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (top: number) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top, behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className="flex flex-col gap-6 items-center lg:items-start text-center lg:text-left whitespace-nowrap">
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold text-lg text-[#192031]" style={{ fontVariationSettings: '"wdth" 100' }}>
        Navigation
      </p>
      <div className="font-['Roboto:Regular',sans-serif] font-normal text-[#9b9b9c] text-[14px] flex flex-col gap-4">
        <p onClick={() => handleNav(1024)} className="cursor-pointer hover:text-black transition-colors">Service</p>
        <p onClick={() => handleNav(2818)} className="cursor-pointer hover:text-black transition-colors">Agency</p>
        <p onClick={() => handleNav(4500)} className="cursor-pointer hover:text-black transition-colors">Case Study</p>
        <p onClick={() => handleNav(6200)} className="cursor-pointer hover:text-black transition-colors">Resource</p>
        <p onClick={() => handleNav(9165)} className="cursor-pointer hover:text-black transition-colors">Contact</p>
      </div>
    </div>
  );
}

function FooterLicense() {
  return (
    <div className="flex flex-col gap-6 items-center lg:items-start text-center lg:text-left whitespace-nowrap">
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold text-lg text-[#192031]" style={{ fontVariationSettings: '"wdth" 100' }}>
        Licence
      </p>
      <div className="font-['Roboto:Regular',sans-serif] font-normal text-[#9b9b9c] text-[14px] flex flex-col gap-4">
        <Link to="/privacy-policy" className="cursor-pointer hover:text-black transition-colors">Privacy Policy</Link>
        <Link to="/terms-and-conditions" className="cursor-pointer hover:text-black transition-colors">Terms of Service</Link>
        <Link to="/refund-policy" className="cursor-pointer hover:text-black transition-colors">Refund Policy</Link>
        <Link to="/service-policy" className="cursor-pointer hover:text-black transition-colors">Service Policy</Link>
        <Link to="/disclaimer" className="cursor-pointer hover:text-black transition-colors">Disclaimer</Link>
      </div>
    </div>
  );
}

function FooterContact() {
  return (
    <div className="flex flex-col gap-6 items-center lg:items-start text-center lg:text-left">
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold text-lg text-[#192031]" style={{ fontVariationSettings: '"wdth" 100' }}>
        Contact
      </p>
      <div className="font-['Roboto:Regular',sans-serif] font-normal text-[#9b9b9c] text-[14px] flex flex-col gap-4">
        <div className="flex items-center gap-2 justify-center lg:justify-start">
          <svg className="size-[20px]" viewBox="0 0 24 24">
            <path d={svgPaths.p34df1400} fill="var(--fill-0, #192031)" />
          </svg>
          <p>Mon–Fri, 9AM–6PM</p>
        </div>
        <div className="flex items-center gap-2 justify-center lg:justify-start">
          <svg className="size-[20px]" viewBox="0 0 24 24">
            <path d={svgPaths.p126a9080} fill="var(--fill-0, #192031)" />
          </svg>
          <p>support@fixezy.in</p>
        </div>
        <div className="flex items-start gap-2 justify-center lg:justify-start">
          <svg className="size-[20px] mt-1 shrink-0" viewBox="0 0 14 19">
            <path d={svgPaths.p239f000} fill="var(--fill-0, #192031)" />
          </svg>
          <p className="max-w-[200px]">Vijayanagar, Bengaluru, Karnataka</p>
        </div>
      </div>
    </div>
  );
}

function FooterInfoLists() {
  return (
    <div className="flex flex-col md:flex-row gap-12 lg:gap-[115px] items-center lg:items-start">
      <FooterNavigation />
      <FooterLicense />
      <FooterContact />
    </div>
  );
}

function FooterBanner() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToContact = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({
          top: 9165,
          behavior: "smooth"
        });
      }, 100);
    } else {
      window.scrollTo({
        top: 9165,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className="relative bg-[#020609] rounded-[30px] px-6 py-8 lg:p-12 w-full flex flex-col gap-6 items-center justify-between lg:flex-row lg:h-[235px]">
      {/* Background decoration in CTA box */}
      <div className="absolute inset-0 overflow-hidden rounded-[30px] pointer-events-none opacity-40">
        <div className="absolute flex h-[2480px] items-center justify-center right-[-430px] top-[-376px] w-[2138px]">
          <div className="-scale-y-100 flex-none rotate-[64.52deg]">
            <img alt="" className="absolute inset-0 object-cover pointer-events-none opacity-60" src={imgImage60} />
          </div>
        </div>
      </div>

      <div className="relative z-10 flex flex-col md:flex-row gap-6 w-full items-center justify-between lg:px-6">
        <h3 className="font-['Plus_Jakarta_Sans:SemiBold',sans-serif] font-semibold text-2xl md:text-5xl lg:text-[80px] text-white tracking-[-2.4px] text-center lg:text-left">
          Want to know more?
        </h3>
        <button 
          onClick={scrollToContact}
          className="bg-[#0f7bf8] flex gap-3 lg:gap-[42px] h-[52px] lg:h-[82px] items-center justify-center px-6 lg:px-[32px] py-3 lg:py-[16px] rounded-full shrink-0 text-white font-['Plus_Jakarta_Sans:Bold',sans-serif] font-bold text-sm lg:text-[16px] hover:bg-blue-600 transition-colors shadow-md hover:scale-105 active:scale-95 transition-transform"
        >
          <p>Get Started</p>
          <div className="relative shrink-0 size-[24px]">
            <svg className="absolute block inset-0 size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
              <path d="M5 12H19" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
              <path d="M12 5L19 12L12 19" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            </svg>
          </div>
        </button>
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <div className="w-full bg-white border-t border-black/5 relative overflow-hidden flex flex-col gap-16 px-6 py-12 lg:h-[635px] lg:w-[1440px] lg:mx-auto lg:block lg:px-0 lg:py-0">
      <div className="relative z-10 flex flex-col gap-12 w-full max-w-5xl mx-auto lg:max-w-none lg:absolute lg:bottom-0 lg:h-[635px] lg:left-1/2 lg:-translate-x-1/2 lg:w-[1440px]">
        {/* Banner call to action */}
        <div className="w-full lg:absolute lg:top-[16px] lg:left-[16px] lg:w-[1408px]">
          <FooterBanner />
        </div>
        {/* Footer link lists */}
        <div className="w-full flex flex-col lg:flex-row gap-12 justify-between items-center lg:items-start lg:absolute lg:left-[80px] lg:top-[335px] lg:w-[1280px]">
          <FooterBranding />
          <FooterInfoLists />
        </div>
      </div>
    </div>
  );
}
